// extracted by mini-css-extract-plugin
export var box = "title-module--box--8M+h4";
export var logo = "title-module--logo--vv5os";
export var subtitle = "title-module--subtitle--x+lsf";
export var title = "title-module--title--c5IZA";